import React, { useState, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '../buttons';
import PhoneTextField from '../phone-text-field';
import { NotificationsContext } from '../../providers/NotificationsProvider';
import { useTranslation } from '../../hooks/useTranslation';
import { useLocation } from '@reach/router';
import useAuth from '../../hooks/useAuth';
import routes from '../../routes';
import { startSmsEnrollment } from './cognito.helper';

const useStyles = makeStyles(theme => ({
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

type Props = {
  mobilePhone: string;
  onNext: (phone: string) => void;
};

type LocationState = {
  forceLogin: boolean;
};

const PhoneDetails = ({ mobilePhone, onNext }: Props) => {
  const classes = useStyles();
  const location = useLocation();
  const { t } = useTranslation();
  const [phone, setPhone] = useState<string>('');
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const { signOut } = useAuth();

  const notificationContext = useContext(NotificationsContext);

  const locationState = (location.state || {}) as LocationState;

  useEffect(() => {
    if (mobilePhone) {
      setPhone(mobilePhone);
    }
  }, [mobilePhone]);

  const sendVerificationCode = async () => {
    if (!phone) {
      return;
    }

    const normalizedPhone = `+1${phone}`;
    setIsDisabled(true);
    try {
      await startSmsEnrollment(normalizedPhone);
      onNext(normalizedPhone);
    } catch (_error) {
      showNotification(t('GENERIC_ERROR_NOTIFICATION_MESSAGE_BODY'), 'error');
    } finally {
      setIsDisabled(false);
    }
  };

  const showNotification = (
    message: string,
    type: 'error' | 'success' = 'success',
  ) => {
    notificationContext.setState({
      isOpen: true,
      message: message,
      severity: type,
    });
    window.scrollTo(0, 0);
  };

  return (
    <Grid container>
      <Grid item xs={12} md={12}>
        <Typography variant={'body1'}>
          {t('TWO_STEP_AUTH_ENTER_PHONE_NUMBER_INFO')}
        </Typography>
      </Grid>
      <Grid item xs={12} md={12}>
        <PhoneTextField
          name="primaryPhone"
          data-testid="primaryPhone"
          label={t('PHONE_NUMBER')}
          value={phone}
          style={{ width: 250 }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setPhone(e.target.value)
          }
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <Button
          className={classes.button}
          variant={'outlined'}
          color={'secondary'}
          onClick={sendVerificationCode}
          disabled={phone.length !== 10 || isDisabled}
        >
          {t('TWO_STEP_AUTH_SEND_VERIFICATION_CODE')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default PhoneDetails;
